// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgc_a bhc_wj bhc_a bhc_q bhc_k","AdSlotMail__mail--notLoaded":"bgc_b bhc_ey bhc_bj bhc_wy","show-ad-not-loaded":"bgc_c","AdSlotMail__cta":"bgc_e"};